module.exports = __webpack_public_path__ + "img/20200311104058485.12dd5813.jpg";